import { ComponentType } from 'react';
import {
  BarChart2Icon,
  BriefcaseIcon,
  ClipboardCheckIcon,
  DownloadIcon,
  FilterIcon,
  ReportingIconProps,
  TrendingUpIcon,
  UsersIcon,
} from './icons';

export interface ReportingTabDef {
  id: string;
  label: string;
  icon: ComponentType<ReportingIconProps>;
}

export const REPORTING_TABS: ReportingTabDef[] = [
  { id: 'overview', label: 'Overview', icon: BarChart2Icon },
  { id: 'recruitment_funnel', label: 'Recruitment Funnel', icon: FilterIcon },
  { id: 'job_performance', label: 'Job Performance', icon: BriefcaseIcon },
  { id: 'candidate_insights', label: 'Candidate Insights', icon: UsersIcon },
  { id: 'assessment_analytics', label: 'Assessment Analytics', icon: ClipboardCheckIcon },
  { id: 'hiring_outcomes', label: 'Hiring Outcomes', icon: TrendingUpIcon },
  { id: 'exports', label: 'Exports', icon: DownloadIcon },
];
